import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-project-kudankulam-hydro-technical-structure',
  templateUrl: './page-project-kudankulam-hydro-technical-structure.component.html',
  styleUrls: ['./page-project-kudankulam-hydro-technical-structure.component.css']
})
export class PageProjectKudankulamHydroTechnicalStructureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner = {
    background: "assets/images/banner/banner-hydro-technical-structure.jpg",
    title: "Kudankulam Hydro Technical Structure",
    crumb: "Kudankulam Hydro Technical Structure"
  }

  images = [
    "assets/images/project/project-kudankulam-hydro-technical-structure.jpg"
  ]

  details = {
    project: "Hydro Electric Plant",
    category: "Installation & Maintenance",
    time: "2 Years",
    status: "Completed",
    client: "L & T Infrastructure"
  }

}
